import request from '@/utils/request'

export async function getModal(data) {
  return request({
    url: '/vehicleType/page',
    method: 'post',
    data,
  })
}
export async function searchModal(data) {
  return request({
    url: '/vehicleType/get',
    method: 'post',
    data,
  })
}
export async function createModal(data) {
  return request({
    url: '/vehicleType/save',
    method: 'post',
    data,
  })
}
export async function updateModal(data) {
  return request({
    url: '/vehicleType/update',
    method: 'post',
    data,
  })
}
export async function deleteModal(data) {
  return request({
    url: '/vehicleType/delete',
    method: 'post',
    data,
  })
}
